import {post,get} from "axios";

export const httpRegisterAsBusiness = (businessData) => {
    const url = "/business/contact";
    return post(url, businessData);
};